import {
    SET_DAYS_TO_PASSWORD_EXPIRATION,
    RESET_DAYS_TO_PASSWORD_EXPIRATION,
} from '../../actions/authentication';
import Constants from '../../utils/Constants';

const daysToPasswordExpiration = (state = null, action = undefined) => {
    switch (action.type) {
        case SET_DAYS_TO_PASSWORD_EXPIRATION:
            return action.payload;
        case RESET_DAYS_TO_PASSWORD_EXPIRATION:
            return Constants.PASSWORD_EXPIRATION_DEFAULT_DAYS;
        default:
            return state;
    }
};

export default daysToPasswordExpiration;
